import { API } from '../../api';
import { WEIXIN_PAY } from '../../weixin'
import { CONFIG } from '../../config';
import { MIX } from '../../utils';

export default {
    namespaced: true,
    state: {
        showDownloadPop: false,
        showWechatPayCode: false,
        wechatPayCodeValue: '',
        wechatPayPrice: 0,
        reportProductData: {},
        talentProductData: {},
        vipProductData: {},
        marriageProductData: {},
    },
    mutations: {},
    actions: {
        // 获取商品列表
        getProductList({ state }, params) {
            API.getProductList(params, function(data) {
                console.log('获取商品列表成功:::::::', params.type, data);
                // 测算相关商品
                let reportList = data.filter(el => el.type == 1);
                reportList.forEach(element => {
                    state.reportProductData[element.pid] = Object.assign(element, {
                        price: parseFloat(element.price/100),
                        rate_price: parseFloat(element.rate_price/100),
                    });
                });
                console.log('reportProductData-----', state.reportProductData);
                // 天赋相关商品
                let talentList = data.filter(el => el.type == 3);
                talentList.forEach(element => {
                    state.talentProductData[element.pid] = Object.assign(element, {
                        price: parseFloat(element.price/100),
                        rate_price: parseFloat(element.rate_price/100),
                    });
                });
                console.log('talentProductData-----', state.talentProductData);
                // 获取VIP商品
                let vipList = data.filter(el => el.type == 4);
                vipList.forEach(element => {
                    state.vipProductData[element.pid] = Object.assign(element, {
                        price: parseFloat(element.price/100),
                        rate_price: parseFloat(element.rate_price/100),
                    });
                });
                console.log('vipProductData-----', state.vipProductData);
                // 合婚产品
                let mrgList = data.filter(el => el.type == 14);
                mrgList.forEach(element => {
                    state.marriageProductData[element.pid] = Object.assign(element, {
                        price: parseFloat(element.price/100),
                        rate_price: parseFloat(element.rate_price/100),
                    });
                })
                console.log('marriageProductData------', state.marriageProductData);
            })
        },
        // 下单
        createPayOrder({ state }, params) {
            API.createOrder(params.params, function(data) {
                console.log('下单成功结果-----', data)
                if(params.mixParams) {
                    MIX.trackOrderCreated(params.mixParams);
                }
                switch(CONFIG.platform) {
                    case 'wechat':
                    case 'wxcy':
                        // 调起微信支付
                        WEIXIN_PAY.createOrder(data.return, function(data) {
                            console.log('clickPay-----支付成功', data)
                            if(params.mixParams) {
                                MIX.trackMoneyPaid(params.mixParams);
                            }
                            if(params.sucCb && typeof(params.sucCb) == 'function') {
                                params.sucCb();
                            }
                        }, function(data) {
                            console.error('clickPay-----支付失败', data)
                            if(params.failCb && typeof(params.failCb) == 'function') {
                                params.failCb();
                            }
                        })
                        break;
                    case 'qq':
                        state.showDownloadPop = true;
                        // state.wechatPayCodeValue = data.return;
                        // state.wechatPayPrice = parseFloat(data.product.price / 100);
                        // setTimeout(() => {
                            // state.showWechatPayCode = true;
                        // }, 20);
                        break;
                    default:
                        if(params.failCb && typeof(params.failCb) == 'function') {
                            params.failCb();
                        }
                        break;
                }
            })
        }
    }
}